import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class EmailOtpResponse extends Entity<EmailOtpResponse> {
    @Expose()
    maskedEmail?: string

    @Expose()
    expiresAt?: string

    @Expose()
    attemptsRemaining?: number

    @Expose()
    rateLimited?: boolean

    @Expose()
    retryAfterSeconds?: number

    @Expose()
    retryAfterMinutes?: number

    @Expose()
    message?: string

    @Expose()
    noEmail?: boolean
}
